import React, { useMemo } from 'react';

import {
  EmptyMessage,
  OffCanvasContent,
  OffCanvasContentData,
  Separador,
  SeparadorTh,
  Table,
  Td,
  Th,
} from './DetailsTable.styles';
import { TableDetailsRow } from './types/table.type';

interface DetailsTableProps {
  row?: TableDetailsRow | null;
  rows?: TableDetailsRow[];
  selectedId?: string | number | null;
  displayValues?: Record<string, string>;
}

const asNode = (key: string, value: unknown): React.ReactNode => {
  if (value == null) return '-';
  if (React.isValidElement(value)) return value;
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (typeof value === 'string' && key.startsWith('data')) return value;
  return value as React.ReactNode;
};

const DetailsTable: React.FC<DetailsTableProps> = ({
  row,
  rows,
  selectedId,
  displayValues,
}) => {
  const resolvedRow = useMemo(() => {
    if (row) return row;
    if (!rows || selectedId === null || selectedId === undefined) return null;
    const selectedIdString = String(selectedId);
    return (
      rows.find(
        (item) =>
          item &&
          item.id !== undefined &&
          item.id !== null &&
          String(item.id) === selectedIdString,
      ) ?? null
    );
  }, [row, rows, selectedId]);

  if (!resolvedRow || Object.keys(resolvedRow).length === 0) {
    return <EmptyMessage>Nenhum detalhe disponível</EmptyMessage>;
  }

  return (
    <OffCanvasContent>
      <OffCanvasContentData>
        <Table>
          <tbody>
            {Object.entries(resolvedRow).map(([key, value], index, array) => {
              const isNextRowSeparator =
                array[index + 1]?.[0]?.includes('separador');
              const label = displayValues?.[key] ?? key;

              if (key.includes('separador')) {
                return (
                  <tr key={`separator-${key}-${index}`}>
                    <SeparadorTh>{label}</SeparadorTh>
                    <Separador>{asNode(key, value)}</Separador>
                  </tr>
                );
              }

              return (
                <tr key={`detail-${key}-${index}`}>
                  <Th
                    style={{
                      borderBottom: isNextRowSeparator
                        ? 'none'
                        : '0.25px solid #e8e9e9',
                    }}
                  >
                    {label}
                  </Th>
                  <Td
                    style={{
                      borderBottom: isNextRowSeparator
                        ? 'none'
                        : '0.25px solid #e9e8e8',
                    }}
                  >
                    {asNode(key, value)}
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </OffCanvasContentData>
    </OffCanvasContent>
  );
};

export default DetailsTable;
